import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { PageContainer, Section } from '../../../shared/ui';
import { appendYowanPreviewQueryIfNeeded } from '../../../app/host/yowanPreviewRouting';
import { requestYowanPasswordReset } from '../app/yowanAuthClient';
import { readYowanAuthAdapter } from '../app/yowanAuthAdapter';
const { yowanPageContent } = require('./pageContent');
const { getYowanRouteMeta } = require('../routes/manifest');

const PasswordResetRequestPage = () => {
  const content = yowanPageContent['/password-reset'];
  const metadata = getYowanRouteMeta('/password-reset');
  const location = useLocation();
  const navigate = useNavigate();
  const auth = readYowanAuthAdapter();
  const currentUser = auth.currentUser;
  const [submitFeedback, setSubmitFeedback] = useState({ message: '', isError: false });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: '',
    },
  });

  useEffect(() => {
    if (!metadata) {
      return;
    }

    document.title = metadata.title;

    if (metadata.description) {
      const descriptionTag = document.querySelector('meta[name="description"]');
      if (descriptionTag) {
        descriptionTag.setAttribute('content', metadata.description);
      }
    }
  }, [metadata]);

  const onSubmit = async (values) => {
    try {
      await requestYowanPasswordReset(values);
      setSubmitFeedback({ message: '', isError: false });
      navigate(appendYowanPreviewQueryIfNeeded('/login', location.search));
    } catch (error) {
      setSubmitFeedback({
        message: '再設定メール送信の受付に失敗しました。時間をおいてお試しください。',
        isError: true,
      });
    }
  };

  return (
    <Section>
      <PageContainer>
        <div className="yowan-auth-support-shell">
          <div className="yowan-auth-support-panel c-surface-content">
            <div className="yowan-auth-support-panel__body">
              <h1 className="yowan-auth-support-panel__title">{content.header.title}</h1>
              {content.header.paragraphs.map((paragraph) => (
                <p key={paragraph} className="yowan-auth-support-panel__lead">
                  {paragraph}
                </p>
              ))}
              {currentUser.isAuthenticated ? (
                <p className="yowan-auth-support-panel__lead">
                  現在ログイン済みです。パスワードを変更する場合は、マイページからお手続きください。
                  <br />
                  <a
                    href={appendYowanPreviewQueryIfNeeded('/mypage', location.search)}
                    className="yowan-auth-support-form__message"
                  >
                    マイページへ
                  </a>
                </p>
              ) : null}
            </div>

            <form className="yowan-auth-support-form c-form" onSubmit={handleSubmit(onSubmit)}>
              <label className="c-form__field">
                <span className="c-form__label">
                  {content.form.labels.email}
                  <em className="c-form__required">*</em>
                </span>
                <input
                  className="c-form__control"
                  type="email"
                  {...register('email', { required: content.form.errors.required })}
                />
                {errors.email ? (
                  <em className="yowan-auth-support-form__error">{errors.email.message}</em>
                ) : null}
              </label>

              <button type="submit" className="c-form__submit">
                {content.form.submitLabel}
              </button>

              {submitFeedback.message ? (
                <p
                  className={
                    submitFeedback.isError
                      ? 'yowan-auth-support-form__error'
                      : 'yowan-auth-support-form__message'
                  }
                >
                  {submitFeedback.message}
                </p>
              ) : null}
            </form>
          </div>
        </div>
      </PageContainer>
    </Section>
  );
};

export default PasswordResetRequestPage;
